import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import SpecialRequirementsEditForm from './SpecialRequirementsEditForm';
import { useParams } from "react-router-dom";
import { EditMode } from "../../../../enums/EditMode";
const EditPage = () => {
    const params = useParams();
    return (_jsx("div", { className: "container-fluid", children: _jsxs("article", { className: "article", children: [_jsx("h2", { className: "article-title", children: "Special Requirement Details" }), _jsx(SpecialRequirementsEditForm, { specialRequirementId: Number(params.specialRequirementId), mode: isNaN(Number(params.specialRequirementId)) ? EditMode.CREATE : EditMode.EDIT })] }) }));
};
export default EditPage;
